import React, { useState, useEffect, useCallback } from 'react';
import Chart from 'react-apexcharts';
import ReactSelect from 'react-select';
import { format } from 'date-fns';
import { toast } from 'react-toastify';
import {
  Container,
  Menus,
  Selects,
  Select,
  Wrapper,
  Filtro,
  DS,
  Button,
} from './styles';
import api from '~/services/api';
// Importando componentes
import Card from '~/components/Card';
import Load from '~/components/Load';

function RelatorioGerais() {
  const [produtos, setProdutos] = useState([]);
  const [dadosAtendimentos, setDadosAtendimentos] = useState([]);
  const [labelCancelamento, setLabelCancelamento] = useState(['Carregar']);
  const [dadosCancelamentos, setDadosCancelamentos] = useState([]);
  const [labelTemperatura, setLabelTemperatura] = useState(['Carregar']);
  const [dadosTemperaturas, setDadosTemperaturas] = useState([]);
  const [dadosFinalizados, setDadosFinalizados] = useState([]);
  const [cidades, setCidades] = useState([]);
  const [produtoId, setProdutoId] = useState(null);
  const [cidadeId, setCidadeId] = useState(null);
  const [dateInit, setDateInit] = useState(null);
  const [dateFinish, setDateFinish] = useState(null);
  const [loading, setLoading] = useState(false);
  const [recarregar, setRecarregar] = useState(false);
  const [reset, setReset] = useState(false);

  const getProdutos = useCallback(() => {
    setRecarregar(true);
    api.get('relatorio-produtos-listagem').then(response => {
      const data = response.data.map(res => {
        return {
          label: res.name,
          value: res.id,
        };
      });

      setProdutos(data);
      setRecarregar(false);
    });
  }, []);

  const getCidades = useCallback(() => {
    setRecarregar(true);
    api.get('cidades').then(response => {
      const data = response.data.map(res => {
        return {
          label: res.name,
          value: res.id,
        };
      });

      setCidades(data);
      setRecarregar(false);
    });
  }, []);

  useEffect(() => {
    getProdutos();
    getCidades();
  }, [getCidades, getProdutos]);

  async function handleProduto(e) {
    try {
      setCidadeId(null);
      setLoading(true);
      const response = await api.post('/relatorio-produtos', {
        produto_id: e.value,
      });
      const data = [
        {
          name: 'canal leads',
          data: [
            response.data.qtd_atendimentos,
            response.data.qtd_atendimentos_iniciado,
            response.data.qtd_atendimento_andamento,
            response.data.qtd_atendimento_cancelados,
            response.data.qtd_atendimentos_finalizados,
          ],
        },
      ];
      const nameLabel = [];
      const infoCount = [];
      response.data.motivos_cancelamentos.forEach(res => {
        nameLabel.push(res.name);
        infoCount.push(res.count);
      });
      const dataCancelamento = [
        {
          name: 'cancelamento',
          data: infoCount,
        },
      ];
      const dataFinalizados = [
        {
          name: 'canal leads finalizados',
          data: [
            response.data.qtd_atendimentos_finalizados_enviados,
            response.data.qtd_atendimentos_finalizados_nao_enviados,
          ],
        },
      ];

      const nameLabelTemperatura = ['Sem Temperatura'];
      const infoCountTemperatura = [response.data.atendimentos_sem_temperatura];

      response.data.temperaturas_motivo.forEach(res => {
        nameLabelTemperatura.push(res.name);
        infoCountTemperatura.push(res.count);
      });

      const dataTemperatura = [
        {
          name: 'tentativa',
          data: infoCountTemperatura,
        },
      ];

      setLabelTemperatura(nameLabelTemperatura);
      setDadosTemperaturas(dataTemperatura);
      setLabelCancelamento(nameLabel);
      setDadosCancelamentos(dataCancelamento);
      setDadosAtendimentos(data);
      setProdutoId(e.value);
      setReset(true);
      setDadosFinalizados(dataFinalizados);
    } catch (error) {
      setLoading(true);
      toast.error('Não foi possivel recuperar os dados, tente novamente.');
    } finally {
      setLoading(false);
    }
  }

  async function handleFiltrar() {
    if (dateInit && dateFinish) {
      const dtI = format(dateInit, 'yyyy-MM-dd');
      const dtF = format(dateFinish, 'yyyy-MM-dd');

      try {
        setLoading(true);
        const response = await api.post('/relatorio-produtos', {
          produto_id: produtoId,
          data_init: dtI,
          data_finish: dtF,
        });
        const data = [
          {
            name: 'canal leads',
            data: [
              response.data.qtd_atendimentos,
              response.data.qtd_atendimentos_iniciado,
              response.data.qtd_atendimento_andamento,
              response.data.qtd_atendimento_cancelados,
              response.data.qtd_atendimentos_finalizados,
            ],
          },
        ];
        const nameLabel = [];
        const infoCount = [];
        response.data.motivos_cancelamentos.forEach(res => {
          nameLabel.push(res.name);
          infoCount.push(res.count);
        });
        const dataCancelamento = [
          {
            name: 'cancelamento',
            data: infoCount,
          },
        ];
        const dataFinalizados = [
          {
            name: 'canal leads finalizados',
            data: [
              response.data.qtd_atendimentos_finalizados_enviados,
              response.data.qtd_atendimentos_finalizados_nao_enviados,
            ],
          },
        ];
        const nameLabelTemperatura = ['Sem Temperatura'];
        const infoCountTemperatura = [
          response.data.atendimentos_sem_temperatura,
        ];

        response.data.temperaturas_motivo.forEach(res => {
          nameLabelTemperatura.push(res.name);
          infoCountTemperatura.push(res.count);
        });

        const dataTemperatura = [
          {
            name: 'tentativa',
            data: infoCountTemperatura,
          },
        ];

        setLabelTemperatura(nameLabelTemperatura);
        setDadosTemperaturas(dataTemperatura);
        setLabelCancelamento(nameLabel);
        setDadosCancelamentos(dataCancelamento);
        setDadosAtendimentos(data);
        setDateInit(null);
        setDateFinish(null);
        setDadosFinalizados(dataFinalizados);
      } catch (error) {
        setLoading(true);
        toast.error('Não foi possivel recuperar os dados, tente novamente.');
      } finally {
        setLoading(false);
      }
    } else {
      toast.error('Preencha os campos data inicial e data final');
    }
  }

  async function handleCidade(e) {
    try {
      setProdutoId(null);
      setLoading(true);
      const response = await api.post('/relatorio-cidades', {
        cidade_id: e.value,
      });
      const data = [
        {
          name: 'canal leads',
          data: [
            response.data.qtd_atendimentos,
            response.data.qtd_atendimentos_iniciado,
            response.data.qtd_atendimento_andamento,
            response.data.qtd_atendimento_cancelados,
            response.data.qtd_atendimentos_finalizados,
          ],
        },
      ];
      const nameLabel = [];
      const infoCount = [];
      response.data.motivos_cancelamentos.forEach(res => {
        nameLabel.push(res.name);
        infoCount.push(res.count);
      });
      const dataCancelamento = [
        {
          name: 'cancelamento',
          data: infoCount,
        },
      ];
      const dataFinalizados = [
        {
          name: 'canal leads finalizados',
          data: [
            response.data.qtd_atendimentos_finalizados_enviados,
            response.data.qtd_atendimentos_finalizados_nao_enviados,
          ],
        },
      ];
      const nameLabelTemperatura = ['Sem Temperatura'];
      const infoCountTemperatura = [response.data.atendimentos_sem_temperatura];

      response.data.temperaturas_motivo.forEach(res => {
        nameLabelTemperatura.push(res.name);
        infoCountTemperatura.push(res.count);
      });

      const dataTemperatura = [
        {
          name: 'tentativa',
          data: infoCountTemperatura,
        },
      ];

      setLabelTemperatura(nameLabelTemperatura);
      setDadosTemperaturas(dataTemperatura);
      setLabelCancelamento(nameLabel);
      setDadosCancelamentos(dataCancelamento);
      setDadosAtendimentos(data);
      setCidadeId(e.value);
      setReset(true);
      setDadosFinalizados(dataFinalizados);
    } catch (error) {
      setLoading(true);
      toast.error('Não foi possivel recuperar os dados, tente novamente.');
    } finally {
      setLoading(false);
    }
  }

  async function handleFiltrarCidade() {
    try {
      setProdutoId(null);
      setLoading(true);
      const dtI = format(dateInit, 'yyyy-MM-dd');
      const dtF = format(dateFinish, 'yyyy-MM-dd');

      const response = await api.post('/relatorio-cidades', {
        cidade_id: cidadeId,
        data_init: dtI,
        data_finish: dtF,
      });
      const data = [
        {
          name: 'canal leads',
          data: [
            response.data.qtd_atendimentos,
            response.data.qtd_atendimentos_iniciado,
            response.data.qtd_atendimento_andamento,
            response.data.qtd_atendimento_cancelados,
            response.data.qtd_atendimentos_finalizados,
          ],
        },
      ];
      const nameLabel = [];
      const infoCount = [];
      response.data.motivos_cancelamentos.forEach(res => {
        nameLabel.push(res.name);
        infoCount.push(res.count);
      });
      const dataCancelamento = [
        {
          name: 'cancelamento',
          data: infoCount,
        },
      ];
      const dataFinalizados = [
        {
          name: 'canal leads finalizados',
          data: [
            response.data.qtd_atendimentos_finalizados_enviados,
            response.data.qtd_atendimentos_finalizados_nao_enviados,
          ],
        },
      ];
      const nameLabelTemperatura = ['Sem Temperatura'];
      const infoCountTemperatura = [response.data.atendimentos_sem_temperatura];

      response.data.temperaturas_motivo.forEach(res => {
        nameLabelTemperatura.push(res.name);
        infoCountTemperatura.push(res.count);
      });

      const dataTemperatura = [
        {
          name: 'tentativa',
          data: infoCountTemperatura,
        },
      ];

      setLabelTemperatura(nameLabelTemperatura);
      setDadosTemperaturas(dataTemperatura);
      setLabelCancelamento(nameLabel);
      setDadosCancelamentos(dataCancelamento);
      setDadosAtendimentos(data);
      setDateInit(null);
      setDateFinish(null);
      setDadosFinalizados(dataFinalizados);
    } catch (error) {
      setLoading(true);
      toast.error('Não foi possivel recuperar os dados, tente novamente.');
    } finally {
      setLoading(false);
    }
  }

  function handleResetar() {
    setReset(false);
    setDadosAtendimentos([]);
    setDadosCancelamentos([]);
    setLabelCancelamento([]);
    setProdutoId(null);
    getProdutos();
    getCidades();
    setCidadeId(null);
  }

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      borderBottom: '1px solid rgba(255,255,255,0.17)',
      backgroundColor: '#323a4e',
      zIndex: '999',
      color: state.isSelected ? '#FFF' : '#dee2e6',
      padding: 10,
      outline: 'none',
    }),
    input: provided => ({
      ...provided,
      color: '#dee2e6',
    }),
    control: provided => ({
      ...provided,
      backgroundColor: '#323a4e',
      border: '1px solid rgba(255, 255, 255, 0.07)',
      color: '#FFF',
      minHeight: 40,
      marginBottom: 0,
      '&:hover': {
        borderColor: 0,
      },
    }),
    placeholder: provided => ({
      ...provided,
      color: '#dee2e6',
    }),
    singleValue: provided => ({
      ...provided,
      color: '#FFF',
      '&:focus': {
        outline: 0,
      },
    }),
  };

  // Configurações do grafico
  const optionsAtendimentos = {
    chart: {
      id: 'basic-bar',
      foreColor: '#373d3f',
    },
    xaxis: {
      categories: [
        'Total',
        'Iniciado',
        'Em Andamento',
        'Cancelados',
        'Finalizados',
      ],
      labels: {
        style: {
          colors: ['#FFF', '#FFF', '#FFF', '#FFF', '#FFF'],
        },
      },
      tooltip: {
        style: {
          colors: ['#000'],
        },
      },
    },
    colors: ['#626ED4'],
  };

  const optionsAtendimentosCancelado = {
    chart: {
      id: 'basic-bar',
      foreColor: '#373d3f',
    },
    xaxis: {
      categories: labelCancelamento.map(label => label),
      labels: {
        style: {
          colors: labelCancelamento.map(() => '#FFF'),
        },
      },
      tooltip: {
        style: {
          colors: ['#000'],
        },
      },
    },
    colors: ['#626ED4'],
  };

  const optionsAtendimentosFinalizado = {
    chart: {
      id: 'basic-bar',
      foreColor: '#373d3f',
    },
    xaxis: {
      categories: ['Enviado', 'Não Enviado'],
      labels: {
        style: {
          colors: ['#FFF', '#FFF'],
        },
      },
      tooltip: {
        style: {
          colors: ['#000'],
        },
      },
    },
    colors: ['#626ED4'],
  };

  const optionsAtendimentosTemperaturas = {
    chart: {
      id: 'basic-bar',
      foreColor: '#373d3f',
    },
    xaxis: {
      categories: labelTemperatura.map(label => label),
      labels: {
        style: {
          colors: labelTemperatura.map(() => '#FFF'),
        },
      },
      tooltip: {
        style: {
          colors: ['#000'],
        },
      },
    },
    colors: ['#626ED4'],
  };

  if (recarregar) {
    return <Load />;
  }

  return (
    <Container>
      <h4>Relatorios Gerais</h4>
      <Card>
        <Menus>
          <Selects>
            <Select>
              <ReactSelect
                styles={customStyles}
                options={produtos}
                placeholder="Selecione um produto"
                onChange={handleProduto}
              />
            </Select>
            <Select>
              <ReactSelect
                styles={customStyles}
                options={cidades}
                placeholder="Selecione uma cidade"
                onChange={handleCidade}
              />
            </Select>
          </Selects>
          {produtoId && (
            <Filtro>
              <DS
                selected={dateInit}
                onChange={date => setDateInit(date)}
                locale="pt-BR"
                placeholderText="Data inicial"
                dateFormat="dd/MM/yyyy"
                showPopperArrow={false}
                withPortal
              />
              <DS
                selected={dateFinish}
                onChange={date => setDateFinish(date)}
                locale="pt-BR"
                minDate={dateInit}
                placeholderText="Data final"
                dateFormat="dd/MM/yyyy"
                showPopperArrow={false}
                withPortal
              />
              <Button type="button" onClick={handleFiltrar}>
                Filtrar
              </Button>

              {reset && (
                <Button type="button" onClick={handleResetar}>
                  Resetar
                </Button>
              )}
            </Filtro>
          )}
          {cidadeId && (
            <Filtro>
              <DS
                selected={dateInit}
                onChange={date => setDateInit(date)}
                locale="pt-BR"
                placeholderText="Data inicial"
                dateFormat="dd/MM/yyyy"
                showPopperArrow={false}
                withPortal
              />
              <DS
                selected={dateFinish}
                onChange={date => setDateFinish(date)}
                locale="pt-BR"
                minDate={dateInit}
                placeholderText="Data final"
                dateFormat="dd/MM/yyyy"
                showPopperArrow={false}
                withPortal
              />
              <Button type="button" onClick={handleFiltrarCidade}>
                Filtrar
              </Button>

              {reset && (
                <Button type="button" onClick={handleResetar}>
                  Resetar
                </Button>
              )}
            </Filtro>
          )}
        </Menus>
      </Card>

      {!loading ? (
        <>
          <Wrapper>
            <Card size={50}>
              <h4>Gráfico de atendimentos</h4>
              <hr />
              <Chart
                options={optionsAtendimentos}
                series={dadosAtendimentos}
                type="bar"
                width="100%"
              />
            </Card>
            <Card size={50}>
              <h4>Gráfico de motivos de cancelamentos</h4>
              <hr />
              <Chart
                options={optionsAtendimentosCancelado}
                series={dadosCancelamentos}
                type="bar"
                width="100%"
              />
            </Card>
          </Wrapper>
          <Wrapper>
            <Card size={50}>
              <h4>Gráfico de Finalizados</h4>
              <hr />
              <Chart
                options={optionsAtendimentosFinalizado}
                series={dadosFinalizados}
                type="bar"
                width="100%"
              />
            </Card>
            <Card size={50}>
              <h4>Gráfico de Temperaturas</h4>
              <hr />
              <Chart
                options={optionsAtendimentosTemperaturas}
                series={dadosTemperaturas}
                type="bar"
                width="100%"
              />
            </Card>
          </Wrapper>
        </>
      ) : (
        <Load />
      )}
    </Container>
  );
}

export default RelatorioGerais;
